import { DefaultButton } from "../common/components/DefaultButton";
import Job from "./Job";
import PanelTitle from "../common/components/PanelTitle";
import JobControlButtons from "./JobControlButtons";
import JobActionButtons from "./JobActionButtons";
import { JobPrintButton } from "./JobPrintButton";
import BeaconButton from "./BeaconButton";
import useClientConfig from "../common/hooks/clientConfigHook";
import JobSOPButton from "./JobSOPButton";
import JobUpdateButton from "./JobUpdateButton";
import { JobParticipantButton } from "./ParticipantButton";
import { useSpecializedTranslation } from "../hooks/specializedTranslationHook";
import { useJobAssistance } from "../reducers/jobAssistanceSlice";
import { useMemo } from "react";
import { canUpdateJob, useJob } from "../reducers/jobSlice";
import useCredentials from "../common/hooks/credentialsHook";
import { useResizeContext } from "../common/components/ResizeablePanel";

const JobPanel = ({ jobid, onPin, onUnpin, onPopout, onClose, onCreate }) => {
    const credentials = useCredentials();
    const clientConfig = useClientConfig();
    const job = useJob(jobid);
    const assistance = useJobAssistance(jobid);
    const { t } = useSpecializedTranslation(job);
    const disabled = useMemo(() => !canUpdateJob(credentials, clientConfig, job, assistance), [credentials, clientConfig, job, assistance]);
    const { width } = useResizeContext();
    
    return <div id="jobPanel" className="px-2">    
        <PanelTitle title={jobid ? t('jobNumber', { count: 1 }) + job.displayid : t('newJob')} guide={78161} onPin={onPin} onUnpin={onUnpin} onPopout={onPopout}>
            <div className="d-flex flex-wrap justify-content-end align-items-stretch" style={{ gap: '0.6rem', minWidth: `min(${width - 40}px,40rem)`, maxWidth: `${width - 40}px` }}>
                <JobSOPButton jobid={jobid}></JobSOPButton>
                { clientConfig.participantJobQueryMapping && jobid && <JobParticipantButton jobid={jobid}></JobParticipantButton> }
                { jobid && <JobUpdateButton jobid={jobid}></JobUpdateButton> }
                {jobid && <JobPrintButton jobid={jobid}></JobPrintButton>}
                {jobid && !disabled && clientConfig.enableBeacon ? <BeaconButton kind="Job" id={jobid}></BeaconButton> : null}
                { !disabled && <JobActionButtons jobid={jobid}></JobActionButtons> }
                { <JobControlButtons onJobEnd={onClose} onJobCreate={onCreate} disabled={disabled} jobid={jobid}></JobControlButtons> }
                {jobid && onClose && <DefaultButton kind="new" layout="stacked" onClick={onClose}></DefaultButton>}
            </div>
        </PanelTitle>
        <Job job={job}></Job>
    </div> 
}

export const SimpleJobPanel = ({ jobid }) => {
    return <JobPanel jobid={jobid}></JobPanel>
}

export default JobPanel;